import { createFileRoute, Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';

const DemoWorkflowPage = () => {
  return (
    <div className='max-w-3xl mx-auto p-6 space-y-6'>
      <h1 className='text-2xl font-semibold'>Demo Workflow</h1>
      <ol className='list-decimal pl-5 space-y-3 text-sm'>
        <li>
          Kundenansicht: Dienst einstellen
          <div className='pt-2'>
            <Button onClick={() => window.dispatchEvent(new CustomEvent('open-new-service-modal'))}>Neuen Dienst anlegen</Button>
          </div>
        </li>
        <li>
          Vertreter: Marktplatz durchsuchen und bewerben
          <div className='pt-2'>
            <Link to='/substitute/marketplace'>
              <Button variant='secondary'>Zum Marktplatz</Button>
            </Link>
          </div>
        </li>
        <li>
          Kunde: Bewerbungen prüfen und annehmen
          <div className='pt-2'>
            <Link to='/provider/services'>
              <Button variant='secondary'>Dienste verwalten</Button>
            </Link>
          </div>
        </li>
        <li>
          Vertreter: Dienst durchführen und Dokumente hochladen
          <div className='pt-2'>
            <Link to='/substitute/services'>
              <Button variant='secondary'>Meine Dienste</Button>
            </Link>
          </div>
        </li>
        <li>
          Kunde: Dokumente prüfen, Rechnung generieren und bezahlen (Demo-Modus möglich)
          <div className='pt-2'>
            <Link to='/provider/payment/success'>
              <Button variant='ghost'>Zahlungs-Success (Demo)</Button>
            </Link>
          </div>
        </li>
      </ol>
    </div>
  );
};

export const Route = createFileRoute('/demo/workflow')({
  component: DemoWorkflowPage,
});
